<template>
    <v-container>
        <v-btn @click="goTest1">TEST1</v-btn>
        <v-btn @click="goTest2">TEST2</v-btn>
        <v-btn @click="goTest3">TEST3</v-btn>
        <v-btn @click="goTest4">TEST4</v-btn>
        <v-btn @click="goTest5">TEST5</v-btn>
        <v-btn @click="goTest6">TEST6</v-btn>
        <v-btn @click="goTest7">TEST7</v-btn>
        <v-btn @click="goTest8">TEST8</v-btn>
        <v-overlay absolute :value="loading">
        	<v-progress-circular indeterminate size="64" width="7" color="cyan darken-4"></v-progress-circular>
        </v-overlay>
	    <v-snackbar v-model="snack.active" :color="snack.type"> {{ snack.text }}
      		<v-btn text dark @click="snack.active = false">Ok</v-btn>
    	</v-snackbar>
        <DialogOne v-if="openDialogOne" :active="openDialogOne" @cancel="onCancel()" @submit="onSubmit($event)" />
        <DialogTwo v-if="openDialogTwo" @cancel="onCancel" @submit="onSubmit($event)" />
        <DialogThree v-if="openDialogThree" @cancel="onCancel" @submit="onSubmit($event)" />
        <Cke v-if="openCke" @cancel="onCancel" @submit="onSubmit($event)" />
    </v-container>
</template>

<script>
import DialogOne from './DialogOne'
import DialogTwo from './DialogTwo'
import DialogThree from './DialogThree'
import Cke from './Cke'
export default {
    name: 'designtests',
    components: {
        DialogOne, DialogTwo, DialogThree, Cke, 
    },
    props: {
    },
    data: () => ({
        loading: false,
        openDialogOne: false,
        openDialogTwo: false,
        openDialogThree: false,
        openCke: false,
        snack: { active: false, type: 'success', text: 'saved',	},
    }),
    computed: {
    },
    methods: {
        goTest1() {
            this.openDialogOne = true
        },
        goTest2() {
            this.openDialogTwo = true
        },
        goTest3() {
            this.openDialogThree = true
        },
        goTest4() {
            this.openCke = true
        },
        goTest5() {
            // this.openDialogOne = true
        },
        goTest6() {
            // this.openDialogOne = true
        },
        goTest7() {
            // this.openDialogOne = true
        },
        goTest8() {
			const url = new URL(window.location.origin)
			const baseURL = url.protocol + '//' + url.hostname
			const path = baseURL + '/tests/8/test'
			window.open(path, "_blank")
        },
        onCancel() {
            this.openDialogOne = false
            this.openDialogTwo = false
            this.openDialogThree = false
            this.openCke = false
        },
        onSubmit(e) {
            console.log(e)
            this.openDialogOne = false
            this.openDialogTwo = false
        },
    },
    mounted() {},
    watch: {},
}
</script>
<style scoped>
</style>